define('all/pretty-links',['module'], function(module) {
	'use strict';

	var config = module.config();
	var map = config.map;
	var reverseMap = config.reverseMap;
	var country = config.country ? '/' + config.country : '';

	var prettyLinks = {};

	prettyLinks.getLink = function(flow, hash) {
		return country + '/' + map[flow.toUpperCase()] + '/' + (hash ? prettyLinks.getHash(hash) : '');
	};

	prettyLinks.getHash = function(hash) {
		// console.log("+++ hash : " + hash);
		if(hash) return '#!' + map[hash.toUpperCase()];
	};

	prettyLinks.getFlowkey = function(linkValueHash){
		var linkValueHashInUpperCase = linkValueHash.toUpperCase();
		var flowKey = linkValueHashInUpperCase;
		if(reverseMap[linkValueHashInUpperCase] !== undefined){
			flowKey = reverseMap[linkValueHashInUpperCase];
		}
		return flowKey;
	};

	return prettyLinks;
});

